import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RentalService } from 'src/app/services/Rental.service';
// import { AdminMarketInfoService } from 'src/app/services/AdminMarketInfo.service';

@Component({
  selector: 'app-market-rule',
  templateUrl: './market-rule.component.html',
  styleUrls: ['./market-rule.component.scss']
})
export class MarketRuleComponent implements OnInit, OnDestroy {

  MarketId: any;
  private subscriptions: Subscription[] = [];

  MarketRulesData: any[] = [];
  filteredMarketRules: any[] = [];
  selectedMarketRule: any = null;

  marketName = '';
  companyId: number | undefined;
  public loaderIcon: Promise<boolean> | undefined;
  SwapORamaCustomChanges = false;
  error: any;

  constructor(
    private route: ActivatedRoute,
    private marketInfoService: MarketInfoService,
    private adminMarketInfoService: MarketInfoService,
    public sanitizer: DomSanitizer,
    private operationRentalService: RentalService
  ) {}

  ngOnInit(): void {
    const routeSubscription = this.route.params.subscribe((params: Params) => {
      this.MarketId = params.marketId;

      this.getMarketDetails();
      this.getMarketRules();
      this.getCustomSettings();
    });

    this.subscriptions.push(routeSubscription);
  }

  getCustomSettings(): void {
    this.operationRentalService
      .getCustomSettings(this.MarketId)
      .subscribe((res: any) => {
        if (res) {
          this.SwapORamaCustomChanges =
            res.SwapORamaCustomChanges ?? false;
        }
      });
  }

  getMarketDetails(): void {
    this.loaderIcon = Promise.resolve(true);

    const sub = this.marketInfoService
      .getMarketDetails(this.MarketId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.marketName = res.MarketName;
          }
          this.loaderIcon = Promise.resolve(false);
        },
        error: (err: any) => {
          this.error = err;
          this.loaderIcon = Promise.resolve(false);
        }
      });

    this.subscriptions.push(sub);
  }

  getMarketRules(): void {
  this.loaderIcon = Promise.resolve(true);

  const sub = this.adminMarketInfoService
    .getMarketRulesDetails(this.MarketId)
    .subscribe({
      next: (res: any) => {
        console.log('Market Rules API response:', res);

        // Your API response is wrapped in res.body.
        const marketRules = Array.isArray(res)
          ? res
          : res?.body ?? res?.Data ?? res?.data ?? [];

        this.MarketRulesData = marketRules
          .filter((rule: any) => {
            const inactive = rule.InActive;

            return inactive === false ||
              inactive === 0 ||
              inactive === '0' ||
              inactive === 'false';
          })
          .sort(
            (a: any, b: any) =>
              Number(a.SortOrder ?? 0) -
              Number(b.SortOrder ?? 0)
          );

        this.filteredMarketRules = [...this.MarketRulesData];

        console.log('Active market rules:', this.filteredMarketRules);

        this.loaderIcon = Promise.resolve(false);
      },
      error: (err: any) => {
        console.error('Error fetching market rules:', err);

        this.error = err;
        this.MarketRulesData = [];
        this.filteredMarketRules = [];

        this.loaderIcon = Promise.resolve(false);
      }
    });

  this.subscriptions.push(sub);
}
 
marketRuleDescription: SafeHtml = '';

openMarketRuleModal(marketRule: any): void {
  this.selectedMarketRule = marketRule;

  this.marketRuleDescription =
    this.sanitizer.bypassSecurityTrustHtml(
      marketRule?.RuleDescription ?? ''
    );
}
  getMarketRuleDescription(): SafeHtml {    
    return this.sanitizer.bypassSecurityTrustHtml(
      this.selectedMarketRule?.RuleDescription ?? ''
    );
  }

  companyIdSevenMile(companyId: number): void {
    this.companyId = companyId;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
